export default __webpack_public_path__ + "static/media/b4.a6b9c248.png";